import { specials } from '@/mocks/homeData';

export default function Specials() {
  return (
    <section id="specials" className="py-20 md:py-28 bg-background-100">
      <div className="w-full max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="h-px w-12 bg-primary-500/50"></span>
            <span className="text-primary-500">◆</span>
            <span className="h-px w-12 bg-primary-500/50"></span>
          </div>
          <span className="text-xs uppercase tracking-[0.3em] text-primary-500/90">Exclusive</span>
          <h2 className="font-heading text-4xl md:text-5xl font-semibold text-foreground-50 mt-4">
            Special Offerings
          </h2>
          <div className="flex items-center justify-center gap-3 my-6">
            <span className="h-px w-12 bg-primary-500/50"></span>
            <span className="text-primary-500">✦</span>
            <span className="h-px w-12 bg-primary-500/50"></span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
          {specials.map((special) => (
            <div
              key={special.title}
              className="bg-background-50 border border-background-200/60 rounded-lg p-8 md:p-10 text-center"
            >
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-primary-500/15 text-primary-500">
                <i className={`${special.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-2xl font-semibold text-foreground-50 mt-6">
                {special.title}
              </h3>
              <p className="mt-2 text-sm text-primary-500 font-medium">{special.time}</p>
              <p className="mt-4 text-sm text-foreground-200/70 leading-relaxed">
                {special.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}